import React from "react";
import { DISCOVERY_GROUPS } from "@/lib/discoveryGroups";

// Multi-select of the six shared categories + primary (must be one of them).
export const PortfolioCategoryPicker = ({ categories = [], primary = "", onChange }) => {
  const toggle = (key) => {
    const next = categories.includes(key) ? categories.filter((k) => k !== key) : [...categories, key];
    const nextPrimary = next.includes(primary) ? primary : next[0] || "";
    onChange(next, nextPrimary);
  };
  return (
    <div data-testid="portfolio-category-picker">
      <div className="text-xs uppercase tracking-widest text-[#A3A3A3]">Portfolio categories</div>
      <div className="mt-2 flex flex-wrap gap-2">
        {DISCOVERY_GROUPS.map((g) => {
          const on = categories.includes(g.key);
          return (
            <button
              key={g.key}
              type="button"
              data-testid={`portfolio-cat-${g.key}`}
              aria-pressed={on}
              onClick={() => toggle(g.key)}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
                on ? "bg-[#FF6600] border-[#FF6600] text-black" : "border-[#2A2A2A] text-[#A3A3A3] hover:border-[#FF6600]/60"
              }`}
            >
              {g.label}
            </button>
          );
        })}
      </div>
      {categories.length > 0 && (
        <label className="mt-3 flex items-center gap-3 text-xs text-[#A3A3A3]">
          Primary
          <select
            data-testid="portfolio-primary-category"
            value={primary}
            onChange={(e) => onChange(categories, e.target.value)}
            className="bg-[#1A1A1A] border border-[#262626] rounded-lg px-3 py-1.5 text-sm text-white focus:outline-none focus:border-[#FF6600]"
          >
            {categories.map((k) => (
              <option key={k} value={k}>{DISCOVERY_GROUPS.find((g) => g.key === k)?.label}</option>
            ))}
          </select>
        </label>
      )}
      <div className="text-[11px] text-[#A3A3A3] mt-2">Project appears under every selected filter. The "Category / Tags" label above still shows on its card.</div>
    </div>
  );
};
